import { colors, spacing, shadows, borderRadius } from '../theme';
// Import all projects
import { riboProject } from './projects/ribo';
import { informProject } from './projects/inform';
import { arcProject } from './projects/arc';
import { pinchProject } from './projects/pinch';

// Re-export theme values for convenience
export { colors, spacing, shadows, borderRadius };

// Navigation items
export const navItems = [
  { href: '#work', label: 'Work' },
  { href: '/about', label: 'About' },
  { href: '/Stephanie Zhang Resume.pdf', label: 'Resume', hasSeparator: true, isExternal: true },
];

// Social links
export const socialLinks = {
  email: 'stephaniey.zhang@alumni.utoronto.ca', // Just the email address, not mailto
  linkedin: 'https://www.linkedin.com/in/stephaniezhang25/',
};

// Achievement data
export const achievements = [
  { 
    href: '/achievement-1', 
    isTextBased: true,
    logo: '/TheHub.png',
    title: 'The Hub Startup Competition',
    subtitle: 'Winner ✦ November 2020',
    floatClass: '1', 
    style: { top: '25%', left: '15%' }, 
    delay: 0.7 
  },
  { 
    href: '/achievement-2', 
    emoji: '⭐', 
    label: 'Featured Work', 
    floatClass: '2', 
    style: { top: '20%', right: '20%' }, 
    hiddenClasses: 'hidden md:flex', 
    delay: 0.8 
  },
  { 
    href: '/achievement-3', 
    emoji: '🎨', 
    label: 'Design Lead', 
    floatClass: '3', 
    style: { bottom: '25%', left: '15%' }, 
    delay: 0.9 
  },
  { 
    href: '/achievement-4', 
    isTextBased: true,
    logo: '/YCombinator.png',
    title: 'YCombinator S2021 Batch',
    subtitle: 'Finalist ✦ May 2021',
    floatClass: '4', 
    style: { bottom: '20%', right: '20%' }, 
    hiddenClasses: 'hidden md:flex', 
    delay: 1.0 
  },
  { 
    href: '/achievement-5', 
    emoji: '💡', 
    label: 'Innovation', 
    floatClass: '5', 
    style: { top: '45%', left: '10%' }, 
    hiddenClasses: 'hidden lg:flex', 
    delay: 1.1 
  },
  { 
    href: '/achievement-6', 
    emoji: '📱', 
    label: 'Mobile First', 
    floatClass: '6', 
    style: { top: '45%', right: '10%' }, 
    hiddenClasses: 'hidden lg:flex', 
    delay: 1.2 
  },
];

// Navigation spacing configuration
export const navSpacing = {
  0: 'ml-[60px]', // Space after name
  1: 'ml-[30px]', // Space between Work and About
  2: 'ml-[30px]', // Space between About and Resume
};

// Tag colors for project cards (WCAG compliant)
export const tagColors = {
  design: 'bg-[#FFB3D1] text-[#4A0A28]',
  develop: 'bg-[#B3E5FC] text-[#003D5C]',
  development: 'bg-[#B3E5FC] text-[#003D5C]',
  mobile: 'bg-[#C8E6C9] text-[#1B4A1B]',
  'mobile app': 'bg-[#C8E6C9] text-[#1B4A1B]',
  website: 'bg-[#FFF9C4] text-[#5C4A00]',
  desktop: 'bg-[#E1BEE7] text-[#2A0A4A]',
  'desktop app': 'bg-[#E1BEE7] text-[#2A0A4A]',
  'website redesign': 'bg-[#FFD4B3] text-[#6B3A1B]',
  'ia': 'bg-[#D4C5F9] text-[#3A1B5C]',
  'IA': 'bg-[#D4C5F9] text-[#3A1B5C]',
  'accessibility': 'bg-[#B3F5E5] text-[#1B4A3A]',
  'web application': 'bg-[#B3D9FF] text-[#1B3A5C]',
};

// Project chapters configuration
export const projectChapters = [
  { id: 'overview', label: 'Overview', icon: 'home' },
  { id: 'the-problem', label: 'The Problem', icon: 'help' },
  { id: 'challenge', label: 'Challenges', icon: 'help' },
  { id: 'problem-1', label: 'Problem 1', icon: 'bug_report' },
  { id: 'problem-2', label: 'Problem 2', icon: 'bug_report' },
  { id: 'problem-3', label: 'Problem 3', icon: 'bug_report' },
  { id: 'results', label: 'Results', icon: 'trending_up' },
  { id: 'visual-treatment', label: 'Brand Identity', icon: 'brush' },
  { id: 'final-design', label: 'Final Design', icon: 'palette' },
];

// Projects data - exported as array for easy iteration
export const projects = [
  riboProject,
  informProject,
  arcProject,
  pinchProject,
];

